/**
 * The larger of the measured bottom clearances, or `undefined` when none
 * applies — which leaves the page's own padding class in charge.
 *
 * The larger, never the sum: the floating ECHO launcher sits ABOVE the mobile
 * tab bar, so adding their clearances reserves the same strip of screen twice.
 */
export function maxClearance(
  ...clearances: (number | undefined)[]
): number | undefined {
  const measured = clearances.filter(
    (clearance): clearance is number => clearance != null,
  );
  return measured.length > 0 ? Math.max(...measured) : undefined;
}
